import { useMemo } from "react";
import { useSelector } from "react-redux";
import { DateTime } from "luxon";

import { RootState } from "../../state/store";
import { useTimezone } from "../Providers/TimezoneProvider";
import { TripleShift } from "../../types/Shift";

interface ShiftTimes {
  shiftStartTime: DateTime;
  shiftEndTime: DateTime;
  selectedDate: DateTime;
	selectedShift: TripleShift;
	isTimezoneLoading: boolean
}

function useShiftTimes(): ShiftTimes {
	const { timezone, isTimezoneLoading } = useTimezone();
  const {
    shiftStartTime,
    shiftEndTime,
    selectedDate: selectedDateStr,
    selectedShift
  } = useSelector((state: RootState) => state.shift);

  const start = useMemo(
		() => {
			return DateTime.fromISO(shiftStartTime!, { zone: timezone! }
			)
		}, [shiftStartTime, timezone]);
	const end = useMemo(
		() => {
			return DateTime.fromISO(shiftEndTime!, { zone: timezone! }
			)
		}, [shiftEndTime, timezone]);
	const selectedDate = useMemo(
		() => DateTime.fromISO(selectedDateStr).toLocal().setZone((timezone ?? "UTC"), { keepLocalTime: true }).startOf("day"),
		[selectedDateStr, timezone]);

  return {
    shiftStartTime: start,
    shiftEndTime: end,
    selectedDate,
		selectedShift,
		isTimezoneLoading
  };
}

export default useShiftTimes;